import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class MonitoringService {

    logException(exception: Error, _severityLevel?: number): void {
        console.error(exception);
    }
}
